export default "__VITE_ASSET__Bpo0vQdv__"